module.exports = __webpack_public_path__ + "static/spectator-c28b38e78200be499721b693f781a09b.png";